import getPaymentIcon from '../../../helpers/billing/getPaymentIcon';
import { getPaymentMethodDisplayText } from '../../../helpers/billing/getPaymentMethodDisplayText';
import { PaymentMethodTypes } from '../constants.ts';
import { getCardSuffix } from '../../../helpers';
import useExistingPaymentMethod from './useExistingPaymentMethod';

const useExistingPaymentMethodDisplay = () => {
  const { existingPaymentType, existingPaymentDetails } = useExistingPaymentMethod();
  const { creditCardType, cardNumber, cardExpiryDateShort } = existingPaymentDetails || {};
  const paymentIcon = getPaymentIcon(existingPaymentType, creditCardType);
  const paymentMethodDisplayText = getPaymentMethodDisplayText(existingPaymentType, cardNumber);
  const paymentAriaLabel =
    (existingPaymentType === PaymentMethodTypes.Card && creditCardType
      ? `${creditCardType}${getCardSuffix(creditCardType)} ending ${cardNumber}`
      : paymentMethodDisplayText) || '';

  return {
    existingPaymentType,
    paymentIcon,
    paymentMethodDisplayText,
    paymentAriaLabel,
    cardExpiryDateShort,
    creditCardType,
  };
};
export default useExistingPaymentMethodDisplay;
